// english
export default {
  find_password_back: 'Return to Login',
  find_password_title: 'Find Password',

  find_password_email: 'Email',
  find_password_email_placeholder: "Please input your account's email",
  find_password_captcha: 'Captcha',
  find_password_captcha_placeholder: 'Please input captcha',
  find_password_success_tip1: 'The link to reset your password, has been successfully sent to',
  find_password_success_tip2:
    'The link is valid for 2 hours, please operate in time to prevent leakage',

  // reset
  find_password_reset_title: 'Reset Password',
  find_password_expired: 'The link has expired',
  find_password_resend: 'Resend Link',
  find_password_new_password: 'New Password',
  find_password_new_password_placeholder: 'Please input new password',
  find_password_confrim_password: 'Confrim Password',
  find_password_confrim_password_placeholder: 'Please confirm new password',
  find_password_strong: 'The password is not strong enough',
  find_password_equal: 'The two password entries are inconsistent',
  find_password_success_tip3: 'Reset password successfully',
};
